import { fetcher } from '@commenda/utils';
import { RootfiSyncActionResponse } from './types';

export interface RetrySyncRequest {
  rootfi_company_id: number;
  rootfi_organisation_id: number;
  sync_id: string;
}

export async function retrySync(
  body: RetrySyncRequest
): Promise<{
  success: boolean;
  data?: RootfiSyncActionResponse;
  error?: unknown;
}> {
  try {
    const response = await fetcher(`rootfi/syncs/${body.sync_id}/retry`, {
      method: 'POST',
      body: {
        rootfi_company_id: body.rootfi_company_id,
        rootfi_organisation_id: body.rootfi_organisation_id,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error retrying sync:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to retry sync',
      };
    }

    const data = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to retry sync';
    console.error('Failed to retry sync:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}

